import { useState, useRef, useEffect, useCallback } from 'react';

export function useEditorRegistry({ whiteboards }) {
  const [mainEditor, setMainEditor] = useState(null);
  const [activeEditorId, setActiveEditorId] = useState(null);
  const [allEditors, setAllEditors] = useState(new Map());
  const allEditorsRef = useRef(new Map());
  const whiteboardsRef = useRef([]);

  useEffect(() => { allEditorsRef.current = allEditors; }, [allEditors]);
  useEffect(() => { whiteboardsRef.current = whiteboards; }, [whiteboards]);

  const setActiveEditorHandler = useCallback((editorId) => {
    setActiveEditorId(editorId);
  }, []);

  const addEditorToMap = useCallback((editorId, editor) => {
    setAllEditors(prev => {
      const next = new Map(prev);
      next.set(editorId, editor);
      return next;
    });
  }, []);

  return {
    mainEditor, setMainEditor,
    activeEditorId, setActiveEditorId,
    allEditors, setAllEditors,
    allEditorsRef,
    whiteboardsRef,
    setActiveEditorHandler,
    addEditorToMap,
  };
}
